/**
 * Email verification API helpers.
 * Calls the user-identity-service endpoints for email verification.
 */

const AUTH_BASE_URL = '/api/user-identity';
const ACCESS_TOKEN_KEY = 'five_ai_access_token';

function getAuthHeaders(): HeadersInit {
  const token = typeof window !== 'undefined' ? localStorage.getItem(ACCESS_TOKEN_KEY) : null;
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export async function sendVerificationEmail(): Promise<{ success: boolean; message: string }> {
  const response = await fetch(`${AUTH_BASE_URL}/api/v1/auth/email/send-verification`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  if (!response.ok) throw new Error('Failed to send verification email');
  return response.json();
}

export async function resendVerificationEmail(): Promise<{ success: boolean; message: string }> {
  const response = await fetch(`${AUTH_BASE_URL}/api/v1/auth/email/resend-verification`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  if (!response.ok) throw new Error('Failed to resend verification email');
  return response.json();
}

export async function checkVerificationStatus(): Promise<{ verified: boolean; email: string }> {
  const response = await fetch(`${AUTH_BASE_URL}/api/v1/auth/email/status`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  if (!response.ok) throw new Error('Failed to check verification status');
  return response.json();
}
